import { cn } from "@omni/utils/styles";

import { useGranite } from "@/redux/modules/value/translations/translations.provider";
import { formatPrice } from "@/utils/price.utils";

type CartItemPriceProps = {
    totalPrice?: number;
    free?: boolean;
    recupel?: number | null;
};

const CartItemPrice = ({ totalPrice, free, recupel }: CartItemPriceProps) => {
    const { t } = useGranite();

    return (
        <div
            className={cn(
                "tw:text-xl tw:md:text-lg tw:relative tw:mt-3 tw:md:mt-0",
                "tw:font-bold tw:mb-0"
            )}
        >
            {formatPrice(
                totalPrice,
                free ? { freeLabel: true, t: t } : undefined
            )}
            {!!recupel && (
                <p
                    className={cn(
                        "tw:mb-0 tw:absolute tw:text-[.6rem] tw:whitespace-nowrap tw:bottom-[-50%] tw:right-0 tw:font-normal"
                    )}
                >
                    {t("ecommerce.label.recupel-included")}
                </p>
            )}
        </div>
    );
};

export { CartItemPrice };
